import MobileGeminiService from './MobileGeminiService';

const MobileWholeResumeService = {
    // Function to generate the entire resume
    generateWholeResume: async (formData, characterLimits, updateStatus) => {
        try {
            let generatedData = {};

            const TARGET_FIELDS = ['title', 'summary', 'experience', 'skills', 'education', 'publications'];
            const DEFAULT_LIMITS = { title: 100, summary: 1500, experience: 1000, skills: 300, education: 500, publications: 500 };

            for (const field of TARGET_FIELDS) {
                const limit = characterLimits?.[field] ?? DEFAULT_LIMITS[field];
                updateStatus(`Generating ${field}...`);
                const currentText = (formData[field] ?? '').toString();
                const generatedText = await MobileGeminiService.generateText(field, currentText, limit, updateStatus);
                const validatedText = await MobileGeminiService.validateAndAdjust(field, generatedText, limit, updateStatus);
                generatedData[field] = validatedText;
            }

            return generatedData;
        } catch (error) {
            console.error('Error generating whole resume:', error);
            throw error;
        }
    },

    // Function to generate a specific section of the resume
    generateSection: async (section, formData, characterLimits) => {
        try {
            const currentText = formData[section];
            const generatedText = await MobileGeminiService.generateText(section, currentText, characterLimits[section], () => {});
            const validatedText = await MobileGeminiService.validateAndAdjust(section, generatedText, characterLimits[section], () => {});
            
            return {
                [section]: validatedText
            };
        } catch (error) {
            console.error(`Error generating ${section}:`, error);
            throw error;
        }
    },

    // Function to generate a cover letter
    generateCoverLetter: async (formData, updateStatus) => {
        try {
            const { jobDescription, companyName, applicantAddress, recipientName, recipientJobTitle, coverLetterBody } = formData;

            updateStatus('Generating cover letter...');

            // Compose the prompt using the job description, company name, and personal details
            const prompt = `
            Generate a professional cover letter for the following job:
            
            Job Description: ${jobDescription}
            Company Name: ${companyName}
            Applicant Address: ${applicantAddress}
            Recipient Name: ${recipientName}
            Recipient Job Title: ${recipientJobTitle}
            
            Main Body:
            ${coverLetterBody}
            
            The cover letter should be personalized, concise, and persuasive, demonstrating how the applicant's skills align with the job requirements.`;

            const generatedCoverLetter = await MobileGeminiService.generateText('coverLetter', prompt, 500, updateStatus);
            const validatedCoverLetter = await MobileGeminiService.validateAndAdjust('coverLetter', generatedCoverLetter, 500, updateStatus);

            return validatedCoverLetter;
        } catch (error) {
            console.error('Error generating cover letter:', error);
            throw error;
        }
    }
};

export default MobileWholeResumeService;
